import useRollbarUtil from "@/components/hooks/useRollbarUtil";
import { AuthContext } from "@/contexts/AuthContext";
import { useAdminUsersAtMikatanoIdQuery } from "@/generated/graphql_billing";
import { useContext } from "react";

export const useAdminUsersAtMikatanoID = () => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();
  const { userInfo } = useContext(AuthContext);

  const { data, loading, refetch } = useAdminUsersAtMikatanoIdQuery({
    onError: getNotifyErrorHandlerForGraphQL(
      "error fetching Mikatano ID admin users"
    ),
    context: {
      api: "billing",
    },
    variables: {
      uuid: userInfo.xCompanyID as never,
    },
  });

  return {
    adminUsersAtMikatanoID: data?.adminUsersAtMikatanoID?.adminUsers || [],
    adminUsersAtMikatanoIDLoading: loading,
    adminUsersAtMikatanoIDRefetch: refetch,
  };
};
